import type { ChipRow } from '@/browse/browse_state'

const FILTERS_SELECTOR = 'aside[aria-label="Filters"]'
const KEYWORD_SEARCH_SELECTOR = `${FILTERS_SELECTOR} input[type="search"]:not(:disabled)`
const ENABLED_FILTER_CONTROL_SELECTOR = `${FILTERS_SELECTOR} :is(input, select, button)[aria-labelledby]:not(:disabled)`

function chipCount(rows: ChipRow[]): number {
  return rows.reduce((count, row) => count + row.chips.length, 0)
}

// A removal that leaves no chips takes the whole chip area off the page, so ActiveFilters has no chip
// left to hand focus to; the sidebar's keyword search is the nearest filter control that stays, unless
// it is disabled for the user, when the first filter control they can use takes focus instead. Filter
// controls are the ones labelled by their section heading, which leaves out heading info buttons that
// unmount as soon as the filters change.
export function focusFilterControlWhenNoChipsRemain(rowsAfterRemoval: ChipRow[]): void {
  if (chipCount(rowsAfterRemoval) > 0) {
    return
  }
  const filterControl = document.querySelector<HTMLElement>(KEYWORD_SEARCH_SELECTOR) ?? document.querySelector<HTMLElement>(ENABLED_FILTER_CONTROL_SELECTOR)
  filterControl?.focus()
}
